import { useState } from "react";
import { Outlet } from "react-router-dom";
import { SidebarNav } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { useI18n } from "@/context/I18nContext";

export default function AppShell() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const { dir } = useI18n();

    return (
        <div className="min-h-screen flex bg-[color:var(--bg-app)]">
            {/* Desktop sidebar — surface cream card that anchors the whole shell */}
            <aside className="hidden lg:flex w-[264px] shrink-0 bg-[color:var(--bg-surface)] border-e border-[color:var(--border-soft)]">
                <SidebarNav />
            </aside>

            {/* Mobile sidebar */}
            <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
                <SheetContent
                    side={dir === "rtl" ? "right" : "left"}
                    className="w-[280px] p-0 bg-[color:var(--bg-surface)]"
                >
                    <SidebarNav onNavigate={() => setMobileOpen(false)} />
                </SheetContent>
            </Sheet>

            <div className="flex-1 min-w-0 flex flex-col">
                <Topbar onMenu={() => setMobileOpen(true)} />
                <main className="flex-1 overflow-y-auto">
                    <div className="max-w-[1400px] mx-auto w-full px-4 sm:px-6 lg:px-8 py-6">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}
